<template>
  <v-list-tile
    class="nx-entity-list-editor-legacy-item"
    :class="{ sortable, cloneable }"
    :key="item.id"
    :target="target"
    :to="editorRoute"
    :event="openModalEditor ? '' : 'click'"
    @click.stop="$emit('click')"
    ripple>

    <v-list-tile-avatar>
      <v-icon>{{ icon }}</v-icon>
    </v-list-tile-avatar>

    <v-list-tile-content class="nx-heading--level-2">
      <v-list-tile-title>{{ title }}</v-list-tile-title>
      <v-list-tile-sub-title>
        <div class="badges">
          <nx-badge v-if="item.creationDate" color="nx-primary--lighten-4 nx-text--level-1">
            {{ item.creationDate | formatDate }}
          </nx-badge>
          <nx-badge v-if="item.modificationDate" color="nx-primary--lighten-4 nx-text--level-1">
            {{ item.modificationDate | formatDate }}
          </nx-badge>
          <nx-badge v-if="item.badges" v-for="(badge, index) in item.badges"
                    :key="index"
                    :color="badgeColor(badge)">
            <span v-if="$te(`message.metadata.${badge.text}`)">{{ $t(`message.metadata.${badge.text}`) }}</span>
            <span v-else>{{ badge.text }}</span>
          </nx-badge>
        </div>
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-flex class="d-flex nx-primary--lighten-4 fill-height py-2">
        <v-layout class="column text-xs-center fill-height w-6">
          <v-tooltip left class="mb-1" v-if="sortable">
            <v-btn icon flat :disabled="disabled"
                   @click.stop.prevent="$emit('moveUp')"
                   slot="activator" color="primary">
              <v-icon>arrow_upward</v-icon>
            </v-btn>
            <span v-html="$t('message.relation.moveUp')"></span>
          </v-tooltip>
          <v-tooltip left v-if="sortable">
            <v-btn icon flat :disabled="disabled"
                   @click.stop.prevent="$emit('moveDown')"
                   slot="activator" color="primary">
              <v-icon>arrow_downward</v-icon>
            </v-btn>
            <span v-html="$t('message.relation.moveDown')"></span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip left v-if="cloneable">
            <v-btn icon flat
                   @click.stop.prevent="$emit('clone')"
                   :disabled="disabled"
                   class="mb-1"
                   slot="activator" color="primary">
              <v-icon>control_point_duplicate</v-icon>
            </v-btn>
            <span v-html="$t('message.relation.clone')"></span>
          </v-tooltip>
          <v-tooltip left v-if="deletable">
            <v-btn icon flat
                   @click.stop.prevent="$emit('remove')"
                   :disabled="disabled"
                   slot="activator" color="primary">
              <v-icon>delete</v-icon>
            </v-btn>
            <span v-html="$t('message.relation.delete')"></span>
          </v-tooltip>
        </v-layout>
      </v-flex>
    </v-list-tile-action>
  </v-list-tile>
</template>
<script>
import NxBadge from '@/components/Badge';
import { mapGetters } from 'vuex';
import { entityEditorRoute } from '@/modules/entity/router';

export default {
  name: 'nx-entity-list-editor-legacy-item',
  components: { NxBadge },
  props: {
    entity: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    sortable: {
      type: Boolean,
    },
    cloneable: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    openModalEditor: {
      type: Boolean,
    },
    target: {
      type: String,
      default: '_self',
    },
    deletable: Boolean,
  },
  computed: {
    ...mapGetters(['getEntityConfig']),
    entityConfig() {
      return this.getEntityConfig(this.entity);
    },
    icon() {
      if (!this.entityConfig || !this.entityConfig.icon) {
        console.error('Bad config: Missing entity icon!', this.entity);
        return 'warning';
      }
      return this.entityConfig.icon;
    },
    title() {
      return this.item.description || this.item.title || this.item.name;
    },
    editorRoute() {
      return entityEditorRoute.get(this.entity, this.item);
    },
  },
  methods: {
    badgeColor(badge) {
      if (badge.color) return badge.color;
      return 'nx-primary--lighten-4 nx-text--level-1';
    },
  },
};
</script>
